import type { NotificationsProps } from "@mantine/notifications";

export const NOTIFICATIONS_CONFIG: NotificationsProps = {
  autoClose: 3000,
  containerWidth: 340,
  limit: 3,
  position: "top-right",
};
